/*import logo from './kc.png';*/
/*function Footer(){

return (  
<>
  {/* component */
  /*<footer className="bg-gradient-to-r from-pink-100 bg-black to-blue-200">
    <div className="max-w-screen-xl px-4 py-16 mx-auto sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div>
          <img src={logo} className="mr-5 h-16 sm:h-9" alt="logo" />
          <p className="max-w-xs mt-4 text-sm text-gray-600">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas,
            accusantium.
          </p>
          <div className="flex mt-8 space-x-6 text-gray-600">
            <a
              className="hover:opacity-75"
              href="https://www.facebook.com/kalyan.chowdhury.908579"
              target="_blank"
              rel="noreferrer"
            >
              <span className="sr-only"> Facebook </span>
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillrule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  cliprule="evenodd"
                />
              </svg>
            </a>
            <a
              className="hover:opacity-75"
              href="https://www.instagram.com/kc_fitness_studio/"
              target="_blank"
              rel="noreferrer"
            >
              <span className="sr-only"> Instagram </span>
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillrule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  cliprule="evenodd"
                />
              </svg>
            </a>
           
          </div>
        </div>
        <div className="grid grid-cols-1 gap-8 lg:col-span-2 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-medium">Company</p>
            <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
              <a className="hover:opacity-75" href="">
                {" "}
                About{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Meet the Team{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                History{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Careers{" "}
              </a>
            </nav>
          </div>
          <div>
            <p className="font-medium">Services</p>
            <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
              <a className="hover:opacity-75" href="">
                {" "}
                1on1 Coaching{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Company Review{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Accounts Review{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                HR Consulting{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                SEO Optimisation{" "}
              </a>
            </nav>
          </div>
          <div>
            <p className="font-medium">Helpful Links</p>
            <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
              <a className="hover:opacity-75" href="">
                {" "}
                Contact{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                FAQs{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Live Chat{" "}
              </a>
            </nav>
          </div>
          <div>
            <p className="font-medium">Legal</p>
            <nav className="flex flex-col mt-4 space-y-2 text-sm text-gray-500">
              <a className="hover:opacity-75" href="">
                {" "}
                Privacy Policy{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Terms &amp; Conditions{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Returns Policy{" "}
              </a>
              <a className="hover:opacity-75" href="">
                {" "}
                Accessibility{" "}
              </a>
            </nav>
          </div>
        </div>
      </div>
      <p className="mt-8 text-xs text-gray-800">© 2022 Comany Name</p>
    </div>
  </footer>
</>
)}
export default Footer*/

import { Link } from "react-router-dom";

const phoneNumber = '9382732250'; // Replace with the recipient's phone number
  const message = 'Hello, this is a pre-filled message!'; // Replace with your message

  const handleWhatsAppClick = () => {
    const url = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.open(url);
  };
function Footer() {
  return (
    <>
      <div className=" bg-gray-900">
        <div className="max-w-2xl mx-auto text-white py-10">
          <div className="text-center">
            <h3 className="text-3xl mb-3"> Full Information Contact Kalyan Chowdhury  </h3>
            <p> Buy what you want. </p>
            <div className="flex justify-center my-10">
            <div className="flex mt-8 space-x-6 text-gray-600">
            <a
              className="hover:opacity-75"
              href="https://www.facebook.com/kalyan.chowdhury.908579"
              target="_blank"
              rel="noreferrer"
            >
              <span className="sr-only"> Facebook </span>
              <svg
                className="w-20 h-20"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillrule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  cliprule="evenodd"
                />
              </svg>
            </a>
           
            <button onClick={handleWhatsAppClick}>
      <button className="bg-green-500 p-2 rounded-lg text-white"> WhatsApp</button> 
    </button>
          </div>
             
            </div>
          </div>
          <div className="mt-28 flex flex-col md:flex-row md:justify-between items-center text-sm text-gray-400">
            <p className="order-2 md:order-1 mt-8 md:mt-0">
              {' '}
              © KC FITNESS STUIDO, 2023.{' '}
            </p>
            <div className="order-1 md:order-2">
              <Link to="/" className="px-2">Products</Link>
              <Link to="/gallery" className="px-2 border-l">Gym Gallery</Link>
              <Link to="/profile" className="px-2 border-l">My profile</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;